import React, { useEffect, useState } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import axios from 'axios';
import { LibraryOrgProvider } from '@/context/LibraryOrgContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LibraryPublicProviders = () => {
  const { orgSlug } = useParams();
  const [org, setOrg] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    let cancelled = false;
    axios.get(`${API}/public/organization-by-slug/${orgSlug}`)
      .then((res) => {
        if (!cancelled) setOrg({ id: res.data.id, slug: res.data.slug || orgSlug, name: res.data.name, logoUrl: res.data.logo_url });
      })
      .catch(() => {
        if (!cancelled) setNotFound(true);
      });
    return () => { cancelled = true; };
  }, [orgSlug]);

  if (notFound) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 text-center p-6">
        <p className="text-slate-500">Deze bibliotheek bestaat niet (meer).</p>
      </div>
    );
  }

  if (!org) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-pulse flex flex-col items-center gap-4">
          <div className="w-12 h-12 rounded-full bg-teal-200"></div>
          <p className="text-slate-500">Bibliotheek laden...</p>
        </div>
      </div>
    );
  }

  return (
    <LibraryOrgProvider org={org}>
      <Outlet />
    </LibraryOrgProvider>
  );
};

export default LibraryPublicProviders;
